import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    window.gtag?.("config", "G-J6TTN6YG4G", {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return null;
}